/**
 * @module Experience/Plan-Details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// CORE
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AemModule } from '@core/aem';

// COMMON MODULE
import { SharedBrowseModule } from '@experience/shop/shared-browse/shared-browse.module';
import { WidgetsModule } from '@support/shared/widgets/widgets.module';

// COMPONENTS
import { PlanDetailsComponent } from '@experience/shop/plan-details/components/plan-details.component';

// SERVICES
import { PlanDetailsService } from '@experience/shop/plan-details/services/plan-details.service';
import { ChangePlansService } from '@experience/change-plan-services/services/change-plans.service';
import { BrowseServicesService } from '@experience/shared-experience/services/browse-service.service';

// ROUTES
import { PLAN_DETAILS_ROUTES } from '@experience/shop/plan-details/plan-details.routes';

@NgModule({
  exports: [PlanDetailsComponent],
  imports: [
    CommonModule,
    AemModule,
    SharedBrowseModule,
    WidgetsModule,
    RouterModule.forChild(PLAN_DETAILS_ROUTES),
  ],
  declarations: [PlanDetailsComponent],
  providers: [PlanDetailsService, ChangePlansService, BrowseServicesService],
})
export class PlanDetailsModule {}
